import { createFileRoute, redirect } from '@tanstack/react-router';

import { getProfileRoles, profileQueryOptions } from 'api/account';

import NoAccounts from 'component/view/NoAccounts';

export const Route = createFileRoute('/n/_auth/no-accounts')({
  beforeLoad: async ({ context }) => {
    const profile = await context.ensureQueryData(profileQueryOptions());
    const roles = getProfileRoles(profile);

    if (!roles.includes('user_with_no_accounts')) {
      throw redirect({
        to: '/n/dashboard',
        replace: true,
      });
    }
  },
  component: NoAccounts,
});
